import { createContext } from 'react';
import once from 'lodash.once';
import type { UseFormResponse, FieldValues } from './types';

export const createFormContext = once(<T extends FieldValues = FieldValues>() =>
  createContext<UseFormResponse<T>>({} as UseFormResponse<T>)
);
